import { createSlice } from '@reduxjs/toolkit'

// Initial state
const initialState = {}

// Create ecSdk slice using Redux Toolkit
const ecSdkSlice = createSlice({
  name: 'ecSdk',
  initialState,
  reducers: {
    setEcSdkData: (state, action) => {
      // Immer handles immutability automatically
      return {
        ...state,
        ...action.payload
      }
    }
  }
})

// Export actions
export const { setEcSdkData } = ecSdkSlice.actions

// Export reducer
export default ecSdkSlice.reducer
